import React from 'react';
import { MainContent } from './layout/main-content-container';
import { PageContainer } from './layout/page-container';
import { WysiwygWithReactLink } from './wysiwyg-with-react-link';


export function ApiErrorPage(props: { error: string }) {

	const { error } = props;

	return (
		<PageContainer>
			<MainContent fullWidth>
				<WysiwygWithReactLink content={error} />
			</MainContent>
		</PageContainer>
	);
}
